import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';

import { ProjectService, FileUploaderService } from '@app/core';
import { RequestStatus, Project, Region, NGXLogger } from '@app/shared';

import {
  ProjectActionTypes,

  GetProjects,
  GetProjectsSuccess,
  GetProjectsFailure,

  GetProject,
  GetProjectSuccess,
  GetProjectFailure,

  RetireProject,
  RetireProjectSuccess,
  RetireProjectFailure,

  RestoreProject,
  RestoreProjectSuccess,
  RestoreProjectFailure,

  SetProject,
  SetProjectSuccess,
  SetProjectFailure,

  UpdateProject,
  UpdateProjectSuccess,
  UpdateProjectFailure,

  GetDocumentSubTypes,
  GetDocumentSubTypesSuccess,
  GetDocumentSubTypesFailure,

  GetPageLayouts,
  GetPageLayoutsSuccess,
  GetPageLayoutsFailure,

  GetMasterRegionTemplates,
  GetMasterRegionTemplatesSuccess,
  GetMasterRegionTemplatesFailure,

  GetPersons,
  GetPersonsSuccess,
  GetPersonsFailure,

  GetPageBackgrounds,
  GetPageBackgroundsSuccess,
  GetPageBackgroundsFailure,

  GetBusinessBrands,
  GetBusinessBrandsSuccess,
  GetBusinessBrandsFailure,

  GenerateProjectCSV,
  GenerateProjectCSVSuccess,
  GenerateProjectCSVFailure,

  ValidateProject,
  ValidateProjectSuccess,
  ValidateProjectFailure,

  GetStudioPref,		
  GetStudioPrefSuccess,		
  GetStudioPrefFailure,

  GetStudios,
  GetStudiosSuccess,
  GetStudiosFailure,

  AssignStudiosToJob,
  AssignStudiosToJobSuccess,
  AssignStudiosToJobFailure,

  AssignStudiosToPage,
  AssignStudiosToPageSuccess,
  AssignStudiosToPageFailure,

  AssignStudiosToPages,
  AssignStudiosToPagesSuccess,
  AssignStudiosToPagesFailure,

  SendPagesToStudio,
  SendPagesToStudioSuccess,
  SendPagesToStudioFailure,

  SendManyPagesToStudio,
  SendManyPagesToStudioSuccess,
  SendManyPagesToStudioFailure,

} from '../actions/project.actions';


@Injectable()
export class ProjectEffects {

  constructor(
    private actions: Actions,
    private projectService: ProjectService,
    private fileUploaderService: FileUploaderService,
    private router: Router,
    private logger:NGXLogger,
  ) {

  }

  // GET PROJECT
  @Effect()
  GetProject: Observable<any> = this.actions
      .ofType(ProjectActionTypes.GET_PROJECT)
      .map((action: GetProject) => action.payload)
      .debounceTime(10)
      .switchMap(payload => {
        return this.projectService.getProject(payload.project.uuid)
          .map((result) => {
            this.logger.debug(result.data);
            //return new LogInSuccess({token: user.token, email: payload.email});
            let project = Object.assign( new Project(), result.data[0] );
            let campaignDoc;
            if(project.campaignStages && project.campaignStages.length && project.campaignStages[0].campaignDocuments && project.campaignStages[0].campaignDocuments.length){
              campaignDoc = project.campaignStages[0].campaignDocuments[0];
              project.authoriserUUID = campaignDoc.authoriserUUID;
              project.projectmanagerUUID = campaignDoc.projectmanagerUUID;
              project.accountManagerUUID = campaignDoc.accountManagerUUID;
            }
            console.log(project);
            return new GetProjectSuccess({project:project});
          })
          .catch((error) => {
            let es:RequestStatus = new RequestStatus();
            es.msg = error.statusText;
            return Observable.of(new GetProjectFailure({ error: es }));
          });
      });


    @Effect({ dispatch: false })
    GetProjectSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PROJECT_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    GetProjectFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PROJECT_FAILURE),

    );f

    // GET PROJECTS
    @Effect()
    GetProjects: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_PROJECTS)
        .map((action: GetProjects) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getProjects(
            payload.searchCriteria.keyword,
            payload.status
          )
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              const updateSearchCriteria = payload.updateSearchCriteria?payload.updateSearchCriteria:false;
              const projects = result.data.map(project => {
                return Object.assign( new Project(), project )
              });
              return new GetProjectsSuccess({
                projects:projects,
                searchCriteria:payload.searchCriteria,
                status:payload.status,
                updateSearchCriteria:updateSearchCriteria
              })
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetProjectsFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetProjectsSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PROJECTS_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    GetProjectsFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PROJECTS_FAILURE),

    );

    @Effect()
    RetireProject: Observable<any> = this.actions
      .ofType(ProjectActionTypes.RETIRE_PROJECT)
      .map((action: RetireProject) => action.payload)
      .debounceTime(10)
      .switchMap(payload => {
        return this.projectService.retireProject(payload.project.uuid)
          .map((result) => {
            this.logger.debug(result);
            let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = "Plan has been retired";

            return new RetireProjectSuccess({payload, successStatus:rs});
          })
          .catch((error) => {
            let es: RequestStatus = new RequestStatus();
            es.msg = error.statusText;
            return Observable.of(new RetireProjectFailure({ error: es }));
          });
      });

    @Effect({ dispatch: false })
    RetireProjectSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.RETIRE_PROJECT_SUCCESS),
      tap((result) => {
        this.logger.debug(result);
      })
    );

    @Effect({ dispatch: false })
    RetireProjectFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.RETIRE_PROJECT_FAILURE)
    );

    @Effect()
    RestoreProject: Observable<any> = this.actions
      .ofType(ProjectActionTypes.RESTORE_PROJECT)
      .map((action: RetireProject) => action.payload)
      .debounceTime(10)
      .switchMap(payload => {
        return this.projectService.restoreProject(payload.project.uuid)
          .map((result) => {
            this.logger.debug(result);
            let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = "Plan has been restored";

            return new RestoreProjectSuccess({payload, successStatus:rs});
          })
          .catch((error) => {
            let es: RequestStatus = new RequestStatus();
            es.msg = error.statusText;
            return Observable.of(new RestoreProjectFailure({ error: es }));
          });
      });

    @Effect({ dispatch: false })
    RestoreProjectSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.RESTORE_PROJECT_SUCCESS),
      tap((result) => {
        this.logger.debug(result);
      })
    );

    @Effect({ dispatch: false })
    RestoreProjectFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.RESTORE_PROJECT_FAILURE)
    );

    // PERSONS
    @Effect()
    GetPersons: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_PERSONS)
        .map((action: GetProjects) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getPersons()
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              result.data.map(person=>person.fullname = person.firstName + ' ' + person.lastName );
              return new GetPersonsSuccess({authorisers:result.data})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetPersonsFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetPersonsSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PERSONS_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    GetPersonsFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PERSONS_FAILURE),

    );


    // DOCUMENT SUB TYPES
    @Effect()
    GetDocumentSubTypes: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_DOCUMENT_SUB_TYPES)
        .map((action: GetDocumentSubTypes) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getDocumentSubTypes()
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetDocumentSubTypesSuccess({documentSubTypes:result.data})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetDocumentSubTypesFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetDocumentSubTypesSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_DOCUMENT_SUB_TYPES_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    GetDocumentSubTypesFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_DOCUMENT_SUB_TYPES_FAILURE),
    );


    // PAGE LAYOUTS
    @Effect()
    GetPageLayouts: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_PAGE_LAYOUTS)
        .map((action: GetPageLayouts) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getPageLayouts()
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetPageLayoutsSuccess({pageLayouts:result.data})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetPageLayoutsFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetPageLayoutsSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PAGE_LAYOUTS_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    GetPageLayoutsFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PAGE_LAYOUTS_FAILURE),
    );


    // Master Region Templates
    @Effect()
    GetMasterRegionTemplates: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_MASTER_REGION_TEMPLATES)
        .map((action: GetMasterRegionTemplates) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getMasterRegionTemplates()
            .map((result) => {
              this.logger.debug(result.data);

              for(let i=0; i<result.data.length; i++){
                let splitarr = result.data[i].values.split(';');
                let regions = [];
                for(let j=0; j<splitarr.length; j++){
                  let region = new Region();
                  region.name = splitarr[j];
                  regions.push(region);
                }
                //result.data[i].values = result.data[i].values.split(';');
                result.data[i].values = regions;
              }
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetMasterRegionTemplatesSuccess({masterRegionTemplates:result.data})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetMasterRegionTemplatesFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetMasterRegionTemplatesSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_MASTER_REGION_TEMPLATES_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    GetMasterRegionTemplatesFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_MASTER_REGION_TEMPLATES_FAILURE),
    );

    // Master Region Templates
    @Effect()
    GetPageBackgrounds: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_PAGE_BACKGROUNDS)
        .map((action: GetPageBackgrounds) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getPageBackgrounds()
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetPageBackgroundsSuccess({pageBackgrounds:result.data})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetPageBackgroundsFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetPageBackgroundsSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    GetPageBackgroundsFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_PAGE_BACKGROUNDS_FAILURE),
    );


    @Effect()
    GetBusinessBrands: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_BUSINESS_BRANDS)
        .map((action: GetBusinessBrands) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getBusinessBrands()
            .map((result) => {
              // this.logger.debug(result.data);
              let arr = [];
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetBusinessBrandsSuccess({businessBrands:result})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetBusinessBrandsFailure({ error: es }));
            });
        });

    @Effect({ dispatch: false })
    GetBusinessBrandsSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_BUSINESS_BRANDS_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    GetBusinessBrandsFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_BUSINESS_BRANDS_FAILURE),
    );

    /*@Effect()
    EditProject: Observable<any> = this.actions
        .ofType(ProjectActionTypes.EDIT_PROJECT)

        .map((action: EditProject) => {

          return new EditProjectSuccess(action.payload)
        })


    @Effect({ dispatch: false })
    EditProjectSuccess: Observable<any> = this.actions.pipe(
          ofType(ProjectActionTypes.EDIT_PROJECT_SUCCESS),
          tap((result) => {

            this.logger.debug(result)
            // localStorage.setItem('token', user.payload.token);
            // this.router.navigateByUrl('/main');
          })
        );*/


    // SETTING CURRENT Project
    /*@Effect()
    SetProject: Observable<any> = this.actions
        .ofType(ProjectActionTypes.SET_PROJECT)
        .map((action: GetProjects) => action.payload)
        .switchMap(payload => {
          return this.projectService.getProject(payload.project)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new SetProjectSuccess({selectedProject:payload.project})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SetProjectFailure({ error: error }));
            });
        });*/


    @Effect({ dispatch: false })
    SetProjectSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.SET_PROJECT_SUCCESS),
      tap((result) => {

        this.logger.debug(result, " SET PROJECT")
        //localStorage.setItem('', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SetProjectFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.SET_PROJECT_FAILURE)
    );


    @Effect()
    UpdateProject: Observable<any> = this.actions
        .ofType(ProjectActionTypes.UPDATE_PROJECT)
        .map((action: GetProjects) => action.payload)
        .switchMap(payload => {
          return this.projectService.updateProject(payload.project)
            .map((result) => {

              if(result.data[0].pmValidations && result.data[0].pmValidations.length && result.data[0].pmValidations[0].type === "ERROR"){

                this.logger.info('throwing error');
                let error = result.data[0].pmValidations[0];
                let rs : RequestStatus = new RequestStatus();
                //rs.code = error.status;
                rs.msg = error.type;
                rs.msg = error.message;
                return new UpdateProjectFailure({ errorStatus: rs });

              }else{
                this.logger.debug(result);
                // add the project to the list of projects
                let proj : Project = result.data[0];
                let rs : RequestStatus = new RequestStatus();

                rs.code = result.code;
                rs.msg = `Plan ${payload.project.name} has been saved`;
                //return new LogInSuccess({token: user.token, email: payload.email});
                return new UpdateProjectSuccess({successStatus:rs, project:proj})
              }

            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to save the Campaign."
              return Observable.of(new UpdateProjectFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    UpdateProjectSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.UPDATE_PROJECT_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    UpdateProjectFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.UPDATE_PROJECT_FAILURE)
    );



    @Effect()
    GenerateProjectCSV: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GENERATE_PROJECT_CSV)
        .map((action: GenerateProjectCSV) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.generateProjectCSV(payload.project)
            .map((result) => {
              this.logger.debug(result);
              console.log('result',result);
              const today = Date.now()
              var datePipe = new DatePipe('en-US');
              const dateStr = datePipe.transform(today, 'dd-MM-yyyy');
              const fileName = `${payload.project.name}-${payload.project.code}-${dateStr}.csv`;

              // const tmpArr = result.message.split('/');
              // const fileSplit = tmpArr[tmpArr.length-1].split('?');
              // const fileName = fileSplit[0];

              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GenerateProjectCSVSuccess({uri:result.message,name:fileName})
            })
            .catch((error) => {
              console.log('error',error)
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              es.msg = "Unable to generate the report";
              return Observable.of(new GenerateProjectCSVFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GenerateProjectCSVSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GENERATE_PROJECT_CSV_SUCCESS),
      tap((result) => {

          this.showFile(result.payload.name,result.payload.uri,'text/csv');

      })
    );

    @Effect({ dispatch: false })
    GenerateProjectCSVFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GENERATE_PROJECT_CSV_FAILURE),
    );

    // Project Validation
    @Effect()
    ValidateProject: Observable<any> = this.actions
        .ofType(ProjectActionTypes.VALIDATE_PROJECT)
        .map((action: ValidateProject) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.validateProject(payload.project.code, payload.project.uuid)
            .map((result) => {
              this.logger.debug(result.data);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              if(result.data[0] === 'failure'){
                return new ValidateProjectSuccess({successStatus:result.data})
              }else{
                rs.msg = `This code is already in use`;
                return new ValidateProjectFailure({ error: rs })
              }
              //return new LogInSuccess({token: user.token, email: payload.email});

            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new ValidateProjectFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    ValidateProjectSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.VALIDATE_PROJECT_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    ValidateProjectFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.VALIDATE_PROJECT_FAILURE),
    );

    // Get Studios
    @Effect()
    GetStudios: Observable<any> = this.actions
        .ofType(ProjectActionTypes.GET_STUDIOS)
        .map((action: GetStudios) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.getStudios()
            .map((result) => {
              this.logger.debug(result);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetStudiosSuccess({studios:result})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetStudiosFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetStudiosSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_STUDIOS_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    GetStudiosFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.GET_STUDIOS_FAILURE),
    );

    @Effect()
    AssignStudiosToJob: Observable<any> = this.actions
        .ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB)
        .map((action: GetStudios) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.assignStudiosToJob(payload.job.uuid,payload.studios)
            .map((result) => {
              this.logger.debug(result);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Studios have been assigned`;

              return new AssignStudiosToJobSuccess({studios:result,successStatus:rs})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new AssignStudiosToJobFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    AssignStudiosToJobSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    AssignStudiosToJobFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_JOB_FAILURE),
    );


    @Effect()
    AssignStudiosToPage: Observable<any> = this.actions
        .ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE)
        .map((action: GetStudios) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.assignStudiosToPage(payload.documentSegment.uuid,payload.studios)
            .map((result) => {
              this.logger.debug(result);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Studios have been assigned`;

              return new AssignStudiosToPageSuccess({studios:result,successStatus:rs})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new AssignStudiosToPageFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    AssignStudiosToPageSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    AssignStudiosToPageFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGE_FAILURE),
    );

    @Effect()
    AssignStudiosToPages: Observable<any> = this.actions
        .ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES)
        .map((action: GetStudios) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.assignStudiosToPages(payload.documentSegment.segmentNumber,payload.studios)
            .map((result) => {
              this.logger.debug(result);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Studios have been assigned`;

              return new AssignStudiosToPagesSuccess({studios:result,successStatus:rs})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new AssignStudiosToPagesFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    AssignStudiosToPagesSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    AssignStudiosToPagesFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.ASSIGN_STUDIOS_TO_PAGES_FAILURE),
    );

    @Effect()
    SendPagesToStudio: Observable<any> = this.actions
        .ofType(ProjectActionTypes.SEND_PAGES_TO_STUDIO)
        .map((action: SendPagesToStudio) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.sendPagesToStudio(payload.jobs,payload.pages)
            .map((result) => {
              this.logger.debug(result);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Studios have been sent`;
              return new SendPagesToStudioSuccess({studios:result,successStatus:rs})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new SendPagesToStudioFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    SendPagesToStudioSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.SEND_PAGES_TO_STUDIO_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    SendPagesToStudioFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.SEND_PAGES_TO_STUDIO_FAILURE),
    );

    @Effect()
    SendManyPagesToStudio: Observable<any> = this.actions
        .ofType(ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO)
        .map((action: SendManyPagesToStudio) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.projectService.sendManyPagesToStudio(payload.jobs,payload.pages)
            .map((result) => {
              this.logger.debug(result);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Pages have been sent`;
              return new SendManyPagesToStudioSuccess({studios:result,successStatus:rs})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new SendManyPagesToStudioFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    SendManyPagesToStudioSuccess: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    SendManyPagesToStudioFailure: Observable<any> = this.actions.pipe(
      ofType(ProjectActionTypes.SEND_MANY_PAGES_TO_STUDIO_FAILURE),
    );

    @Effect()	
    GetStudioPref: Observable<any> = this.actions	
        .ofType(ProjectActionTypes.GET_STUDIO_PREF)	
        .map((action: GetStudioPref) => action.payload)	
        .debounceTime(10)	
        .switchMap(payload => {	
          return this.projectService.getStudioPref()	
            .map((result) => {	
              this.logger.debug(result);	
              //return new LogInSuccess({token: user.token, email: payload.email});	
              return new GetStudioPrefSuccess({studioPref:result})	
            })	
            .catch((error) => {	
              let es:RequestStatus = new RequestStatus();	
              es.msg = error.statusText;	
              return Observable.of(new GetStudioPrefFailure({ error: es }));	
            });	
        });	
    @Effect({ dispatch: false })	
    GetStudioPrefSuccess: Observable<any> = this.actions.pipe(	
      ofType(ProjectActionTypes.GET_STUDIO_PREF_SUCCESS),	
      tap((result) => {	
        this.logger.debug(result)	
      })	
    );	
    @Effect({ dispatch: false })	
    GetStudioPrefFailure: Observable<any> = this.actions.pipe(	
      ofType(ProjectActionTypes.GET_STUDIO_PREF_FAILURE),	
    );

    private showFile(name:string,uri:string,type:string): void {

        this.fileUploaderService.downloadFile(uri)
            .subscribe(x => {
                // It is necessary to create a new blob object with mime-type explicitly set
                // otherwise only Chrome works like it should
                var newBlob = new Blob([x], { type: "text/csv" });

                // IE doesn't allow using a blob object directly as link href
                // instead it is necessary to use msSaveOrOpenBlob
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(newBlob);
                    return;
                }

                // For other browsers:
                // Create a link pointing to the ObjectURL containing the blob.
                const data = window.URL.createObjectURL(newBlob);

                var link = document.createElement('a');
                link.href = data;
                link.download = name;
                // this is necessary as link.click() does not work on the latest firefox
                link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

                setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(data);
                    link.remove();
                }, 100);
            });
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/project.effects.ts